export default __webpack_public_path__ + "static/media/logoT.5c895eb5.png";